import { Typography } from 'antd';
import { USER_OPTIONS } from 'common/constants';
import { useTracking } from 'common/utils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from 'src/structure-template/sider-navbar/sider-navbar-mobile.style';

import { ProfileDrawerTitle } from '../profile-drawer-title/profile-drawer-title.component';
import { RadioGroup } from './profile-drawer-select-language.style';

interface ProfileDrawerSelectLanguageProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProfileDrawerSelectLanguage: FC<ProfileDrawerSelectLanguageProps> = ({
  isOpen,
  onClose,
}) => {
  const { t, i18n } = useTranslation();
  const { track } = useTracking();

  const handleLanguageChange = (language: string) => {
    track('Profile Drawer - Language Changed', {
      language,
    });
    i18n.changeLanguage(language);
    onClose();
  };

  return (
    <Styled.DrawerLayout
      open={isOpen}
      width="100vw"
      closable={false}
      className="select-language-drawer"
    >
      <ProfileDrawerTitle
        title={t('profile.drawer.select_language.title')}
        onBack={onClose}
      />
      <RadioGroup
        buttonStyle="solid"
        options={USER_OPTIONS.AVAILABLE_LANGUAGES.map((lang) => ({
          label: (
            <Typography>{t(`profile.drawer.languages.${lang}`)}</Typography>
          ),
          value: lang,
        }))}
        defaultValue={i18n.language}
        onChange={(e) => handleLanguageChange(e.target.value)}
      />
    </Styled.DrawerLayout>
  );
};

export { ProfileDrawerSelectLanguage };
